import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'CompanyHome',
  //   description: 'description of CompanyHome',
  //   url: '/company-home',
  // },
];

export default help;
